import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import EventTypeAddChild from "./EventTypeAddChild";

const EventTypeAdd = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <EventTypeAddChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default EventTypeAdd;
